interface FullWidthSeparatorProps {
  className?: string;
}

/**
 * @component FullWidthSeparator
 * @description A reusable horizontal separator component that spans the full width of its container.
 */
function FullWidthSeparator({ className = "" }: FullWidthSeparatorProps) {
  return <div className={`h-px w-full bg-border-base my-6 ${className}`} />;
}

export default FullWidthSeparator;
